import React, { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import DataTable from "react-data-table-component";
import { AjaxSourced } from "../../../../../types/Tables";
import { AjaxSourcedDataTitle } from "../../../../../constants";
import FilterComponent from "../common/FilterComponent";
import { AjaxSourcedColumns, AjaxSourcedTableData, AjaxTableSubTitle } from "../../../../../data/formsAndTable/tables/dataTables/DataSource";
import CommonCardHeader from "../../../../../coreComponents/CommonCardHeader";

const AjaxSourcedData = () => {
  const [filterText, setFilterText] = useState("");
  const filteredItems: AjaxSourced[] = AjaxSourcedTableData.filter((item: AjaxSourced) => Object.values(item).some((value) => value && value.toString().toLowerCase().includes(filterText.toLowerCase())));
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader tag headClass="pb-0 card-no-border" title={AjaxSourcedDataTitle} span={AjaxTableSubTitle} tagClass="mb-3" />
        <CardBody>
          <FilterComponent onFilter={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)} filterText={filterText} />
          <div className="table-responsive">
            <DataTable className="custom-scrollbar" data={filteredItems} columns={AjaxSourcedColumns} pagination striped />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default AjaxSourcedData;
